import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { ChangeEvent } from "react";
import { UseQueryResult } from "react-query";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";

type Props = {
  setSelectedAccounts: React.Dispatch<React.SetStateAction<{ id: string; name: string; isPostingEnabled: boolean }[]>>,
  selectedAccounts: { id: string; name: string; isPostingEnabled: boolean }[],
  pagesQuery: UseQueryResult<any[], unknown>
}

export default function AccountsForm({
  setSelectedAccounts,
  selectedAccounts,
  pagesQuery
}: Props) {
  const handleAccountSelectionChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = ev.target;
    setSelectedAccounts(artists => {
      return checked ? [...artists, pagesQuery.data?.find(pq => pq.id === value) as { id: string; name: string; isPostingEnabled: boolean }] : artists.filter(x => x.id !== value);
    });
  }

  return (
    <SpinnerWrapper loading={pagesQuery.isLoading}>
      <Box display="flex" flexDirection="column" sx={{ mt: 1, pb: 1 }}>
        {pagesQuery.data
          ?.filter(d => !d.id) // Render readonly labels for accounts with empty ID
          .map(page => <FormControlLabel
            key={page.name}
            control={<span></span>}
            label={`${page.name}${selectedAccounts.some(sa => (sa.name ?? "").trim().toLowerCase() === (page.name ?? "").trim().toLowerCase() && sa.isPostingEnabled) ? " (Posting Enabled)" : ""}`}
            sx={{ fontStyle: "bold" }}
          />)}
        {pagesQuery.data?.filter(d => d.id !== null).map(page =>
        (<FormControlLabel
          key={page.id}
          control={
            <Checkbox
              value={page.id}
              checked={selectedAccounts.map(sa => sa.id).includes(page.id)}
              onChange={handleAccountSelectionChange}
            />
          }
          label={`${page.name}${selectedAccounts.some(sa => sa.id === page.id && sa.isPostingEnabled) ? " (Posting Enabled)" : ""}`}
        />
        ))}
      </Box>
    </SpinnerWrapper>
  );
}